<template>
  <el-card class="box-card" v-loading="isLoading">
    <div slot="header" class="clearfix">
      <span class="form-header">Indicador - Novo</span>
    </div>
    <div class="row">
      <div class="col">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item label="Nome" prop="field" v-bind:error="errors.nome">
            <el-input v-model="form.nome" size="medium" autosize></el-input>
          </el-form-item>
          <el-form-item label="Superior" prop="parent_id" :error="errors.parent_id">
            <el-select v-model="form.parent_id" placeholder="Superior" clearable filterable>
              <el-option
                v-for="item in indicadoresOrdenados"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Unidade" prop="unidade" :error="errors.unidade">
            <el-select v-model="form.unidade_id" placeholder="Unidade">
              <el-option
                v-for="item in unidades"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Requisito">
            <el-radio-group v-model="form.requisito_id" size="medium">
              <el-radio border label="1">Maior Melhor</el-radio>
              <el-radio border label="2">Menor Melhor</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Fórmula" prop="formula_id" :error="errors.formula_id">
            <el-select v-model="form.formula_id" placeholder="Formula" clearable>
              <el-option
                v-for="item in formulas"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="medium"
            v-for="n in quantidadePerguntas"
            :label="'Pergunta ' + n"
            :key="'pergunta_'+n">

            <el-select
              size="large"
              autosize
              filterable
              allow-create
              v-model="form.perguntas[`p_${n}`]"
              placeholder="Pergunta">
              <el-option
                v-for="item in perguntas"
                :key="item.id"
                :label="item.descricao"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="bottom clearfix">
            <el-button type="primary" style="float: right;margin: 20px" @click="salvar()">Salvar
            </el-button>
            <el-button type="danger" style="float: right;margin: 20px" @click="cancelar()">Cancelar</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </el-card>

</template>

<script>
  import ElCard from "element-ui/packages/card/src/main";
  import {mapActions} from 'vuex'
  import ElForm from "element-ui/packages/form/src/form";

  export default {
    components: {
      ElForm,
      ElCard
    },
    name: "indicador-create",
    data() {
      return {
        indicadores: [],
        formulas: [],
        requisitos: [],
        unidades: [],
        perguntas: [],
        errors: {},
        isLoading: false,
        form: {
          perguntas: {}
        }
      }
    },
    methods: {
      ...mapActions('Indicador', ['setIndicador']),
      cancelar() {
        this.$router.push({name: 'indicador.index'})
      },
      async load() {
        try {
          this.isLoading = true
          const {data: {formulas, unidades, requisitos, perguntas, indicadores}} = await axios.get(`${process.env.API_PATH}/indicador/create`)
          this.indicadores = indicadores
          this.formulas = formulas
          this.unidades = unidades
          this.requisitos = requisitos
          this.perguntas = perguntas
        }
        catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      },
      async salvar() {
        this.isLoading = true
        this.errors = []
        try {
          const response = await this.setIndicador({...this.form})
          this.form = {
            perguntas: {}
          }
          this.$notify.success("Registro Salvo com sucesso!")
        } catch (error) {
          console.log(error.response)
          this.errors = error.response.data.errors
        }
        this.isLoading = false
      }
    },
    computed: {
      indicadoresOrdenados()
      {
        if(this.indicadores)
        {
          return collect(this.indicadores).sortBy('nome').all()
        }
        return []
      },
      quantidadePerguntas() {
        const formula = collect(this.formulas).firstWhere('id', this.form.formula_id)
        if (formula) {
          return collect(formula.macro.match(/p_./g) || []).unique().count()
        }
        return 0
      }
    },
    async mounted() {
      await this.load()
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/features/Indicador/Create.vue